import { render, staticRenderFns } from "./SegmentsQuestions.vue?vue&type=template&id=73e1168a&"
import script from "./SegmentsQuestions.vue?vue&type=script&lang=js&"
export * from "./SegmentsQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports